import React from 'react';
import { Section } from 'shared/ui/Section';
import { Picker } from 'shared/ui/Picker';
import { useReportSectionStatus } from 'shared/state/sectionStatusContext';
import { useSubscriptionSection } from './useSubscriptionSection';

export function SubscriptionSection({ id }: { id: string }) {
  const s = useSubscriptionSection();
  useReportSectionStatus(id, s.status);
  return (
    <Section.Root id={id} defaultOpen>
      <Section.Bar title="Subscription" role="Delivery, term, service" summary={s.summary} />
      <Section.Body>
        <div className="grid gap-4 md:grid-cols-3">
          <Picker id="quarter" label="Delivery Quarter" gate={s.quarterGated ? 'Special pricing' : undefined}
            options={s.quarterOptions} value={s.quarter} onChange={s.onQuarterChange} />
          <Picker id="term" label="Subscription Duration" hint={s.termHint}
            options={s.monthOptions} value={s.months} onChange={s.onMonthsChange} />
          <Picker id="service" label="Service Option"
            options={s.serviceOptions} value={s.serviceOption} onChange={s.onServiceChange} />
        </div>
      </Section.Body>
    </Section.Root>
  );
}
